export const mockCityList = [{
  id: '110000',
  value: '110000',
  title: '北京市',
  type: '04',
  isLeaf: true,
}, {
  id: '120000',
  value: '120000',
  title: '天津市',
  type: '04',
  isLeaf: true,
}, {
  id: '310000',
  value: '310000',
  title: '上海市',
  type: '04',
  isLeaf: true,
}, {
  id: '500000',
  value: '500000',
  title: '重庆市',
  type: '04',
  isLeaf: true,
}, {
  id: '810000',
  value: '810000',
  title: '香港特别行政区',
  type: '04',
  isLeaf: true,
}, {
  id: '820000',
  value: '820000',
  title: '澳门特别行政区',
  type: '04',
  isLeaf: true,
}];
